import store from '../../../init/store.js'
import {setBattleValue} from '../../../redux-actions/battle-actions.js'
import {handleRolloutStep} from '../../lifecycle/handle-new-rollout.js'

/** Moves on to next rollout step */
export function handleAnimationEnd() {
//Fire the "next step" thing to tell rollout to move on.
  setBattleValue({
    arenaAnimationComponent: null, //Clear the animation component (otherwise it will remain mounted)
    rolloutExecutingIndex: store.getState().battle.rolloutExecutingIndex + 1
  });
  handleRolloutStep();
}

export function clearArenaAnimations() {
  setBattleValue({
    arenaAnimationComponent: null,
    arenaBackgroundStyle: "rgba(0,0,0,0)",
  });
}

export function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}


// WEBPACK FOOTER //
// ./src/battle/ArenaView/animation-components/animation-lifecycle-utilities.js